import { Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";
import { PiCaretDownFill } from "react-icons/pi";
import { TableCellBasic } from "./MainTable";
import { TableCell, TableRow } from "./Table";

interface RowWithDropdownProps {
  row: any;
  rowBgColor: string;
  rowBorder: string;
  columnOrder: string[];
  isLeftScrollable: boolean;
  isRightScrollable: boolean;
  components?: any;
  renderRowDropdown: (row: any) => React.ReactNode;
}

export function RowWithDropdown({
  row,
  rowBgColor,
  rowBorder,
  columnOrder,
  isLeftScrollable,
  isRightScrollable,
  components,
  renderRowDropdown,
}: any) {
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <TableRow className={rowBgColor + " " + rowBorder}>
        {row.getVisibleCells().map((cell: any) => {
          const bodyCellParam = {
            cell,
            columnOrder,
            isLeftScrollable,
            isRightScrollable,
          };
          return (
            <Fragment key={cell.id}>
              {components?.bodyCell ? (
                components.bodyCell(bodyCellParam)
              ) : (
                <TableCellBasic
                  cell={cell}
                  isLeftScrollable={isLeftScrollable}
                  isRightScrollable={isRightScrollable}
                />
              )}
            </Fragment>
          );
        })}
        <TableCell className="relative w-12 text-center">
          <button
            type="button"
            className="inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors"
            onClick={() => setOpen((v) => !v)}
            aria-label="Mostrar opciones"
          >
            <PiCaretDownFill
              className={`transition-transform duration-200 ${open ? "rotate-180" : "rotate-0"}`}
              size={18}
            />
          </button>
        </TableCell>
      </TableRow>
      <Transition
        show={open}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 -translate-y-2"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 -translate-y-2"
      >
        <TableRow>
          <TableCell colSpan={row.getVisibleCells().length + 1} className="bg-gray-50 !p-0">
            <div className="p-4">
              {renderRowDropdown(row.original)}
            </div>
          </TableCell>
        </TableRow>
      </Transition>
      {/* custom-expanded-component start  */}
      {components?.expandedComponent && row.getIsExpanded() && (
        <TableRow>
          <TableCell className="!p-0" colSpan={row.getVisibleCells().length + 1}>
            {components.expandedComponent(row)}
          </TableCell>
        </TableRow>
      )}
      {/* customExpandedComponent end */}
    </Fragment>
  );
}

export default RowWithDropdown;